import { ReactComponent as AppointmentIcon } from "../img/My-Clinic/appointment.svg";
import { ReactComponent as PaymentIcon } from "../img/My-Clinic/rupee.svg";
import { ReactComponent as MessageIcon } from "../img/My-Clinic/message.svg";
import BottomNav from "../components/bottomNav";
import SideNav from "../components/sideNav";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import createPersistedState from "use-persisted-state";

// import { ReactComponent as ChatDoctorIcon } from "../img/icons/icon_chat_doctor.svg";
// import { Link } from "react-router-dom/cjs/react-router-dom";

const useIsChatButtonEnabledState = createPersistedState("isChatButtonEnabled");

function MyClinicPage({}) {
  let history = useHistory();
  const { t } = useTranslation();
  const [isChatButtonEnabled, setIsChatButtonEnabled] =
    useIsChatButtonEnabledState();

  return (
    <>
      <SideNav />
      <div className="body_content py-5">
        <div className="inner_body ">
          <ul className="list-unstyled list_dashboard flex-column">
            <li className="pt-4">
              <a onClick={() => history.push("/my-appointments")}>
                <span className="icon">
                  <AppointmentIcon className="img-fluid" />
                </span>
                <span className="txt">
                  {t("appointment.MYCLINIC.appointment")}
                </span>
              </a>
            </li>
            <li className="pt-4">
              <a href="#">
                <span className="icon">
                  <PaymentIcon className="img-fluid" />
                </span>
                <span className="txt">{t("appointment.MYCLINIC.payment")}</span>
                <span className="coming_soon">
                  {t("appointment.MYCLINIC.coming")}
                </span>
              </a>
            </li>
            {/* <li className="pt-4">
              <a href="#">
                <span className="icon">
                  <MessageIcon className="img-fluid" />
                </span>
                <span className="txt">{t("appointment.MYCLINIC.message")}</span>
                <span className="coming_soon">
                  {t("appointment.MYCLINIC.coming")}
                </span>
              </a>
            </li> */}
          </ul>
          <BottomNav
            option="my-clinic"
            isChatButtonEnabled={isChatButtonEnabled}
          />
        </div>
        {/* <Link to="/chat">
          <ChatDoctorIcon
            style={{ position: "fixed", right: "5px", bottom: "80px" }}
          />
        </Link> */}
      </div>
    </>
  );
}

export default MyClinicPage;
